/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The configuration of the animatic for an exhaust fan.
 */
export type AnimaticExhaustFanConfig = {};

/** @internal */
export const AnimaticExhaustFanConfig$inboundSchema: z.ZodType<
  AnimaticExhaustFanConfig,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type AnimaticExhaustFanConfig$Outbound = {};

/** @internal */
export const AnimaticExhaustFanConfig$outboundSchema: z.ZodType<
  AnimaticExhaustFanConfig$Outbound,
  z.ZodTypeDef,
  AnimaticExhaustFanConfig
> = z.object({});

export function animaticExhaustFanConfigToJSON(
  animaticExhaustFanConfig: AnimaticExhaustFanConfig,
): string {
  return JSON.stringify(
    AnimaticExhaustFanConfig$outboundSchema.parse(animaticExhaustFanConfig),
  );
}
export function animaticExhaustFanConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticExhaustFanConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticExhaustFanConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticExhaustFanConfig' from JSON`,
  );
}
